import React from 'react'
import listOfCountries from './data-countries-2020.csv'
import chroma from 'chroma-js'
import { SparkLineWrapper } from 'components/sparkLineWrapper'
import './styles.scss'

function CountryList(props) {
  return listOfCountries.map((item, index) => {
    // chroma scale Color
    const colorScale = chroma
      .scale(['#2CA29F', '#f9c764', '#D07800', '#D3343F', '#A756A3'])
      .mode('rgb')
      .domain([1.5, 1.75, 2.5, 3.5, 4])

    const indexNull = index === 0

    return (
      <div key={'_' + index}>
        {/*
        {indexNull && <div>kopfzeile</div>} */}
        <div className='ta text'>
          <div
            className={
              item.graphic === 'ja' ? 'itemWrapper itemGraphic' : 'itemWrapper'
            }
          >
            <div
              className={
                item.valueColor === '4' ||
                item.valueColor === '3.5' ||
                item.valueColor === '2.5' ||
                item.valueColor === '1.5'
                  ? 'leftSide white'
                  : 'leftSide black'
              }
              // className='leftSide'
              style={{ backgroundColor: colorScale(item.valueColor) }}
            >
              <div>+{item.Description}°C</div>
            </div>

            <div className='rightSide'>
              <div className='contentOne'>
                {/* <div className='rang'>{item.Rang}</div> */}
                <div>{item.Name}</div>
                <div className='trend'>
                  <i className={'icon small arrow' + ' ' + item.trend} />
                  <span>Trend</span>
                </div>
              </div>
              <div className='barWrapper'>
                <div
                  className='bar'
                  style={{ width: item.eNormalisiert + '%' }}
                />
              </div>
              <div className='barByline'>
                {item.Emissionen.toString().replace(/\./g, ',')} tCO₂ pro Kopf 2018
              </div>
            </div>
          </div>
          {/* className={item.Graphic === 'nein' ? ('noBorderBottom itemWrapper') : ('itemWrapper')} */}

          <SparkLineWrapper country={item.Name} />
        </div>
      </div>
    )
  })
}
export { CountryList }
